var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 7.90936C14.5 11.7754 11.366 14.9094 7.5 14.9094C3.63401 14.9094 0.5 11.7754 0.5 7.90936C0.5 4.04337 3.63401 0.909363 7.5 0.909363C11.366 0.909363 14.5 4.04337 14.5 7.90936ZM8.42085 6.08002L7.93552 9.91291H7.05196L6.57907 6.08002V3.69069H8.42085V6.08002ZM6.5293 10.6596V12.576H8.48307V10.6596H6.5293Z","fill":"#CA8A04"}));
}

Alert.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = Alert;

Alert.default = Alert;
